import { ILGPPreview } from '@sky-it-livedata/livedata-sports-design-system';
import { isValidLgpPreview } from './typeguards';
import { LgpPreviewQuery } from '../types';
import { CreateLgpPreviewWidgetInputSchema } from 'appsync';
import { WidgetError, ErrorName } from '../../../utils/errors';

export default (obj: LgpPreviewQuery): ILGPPreview => {
  if (isValidLgpPreview(obj)) {
      CreateLgpPreviewWidgetInputSchema().parse(obj.data.getLgpPreviewWidget, {reportInput: true});
      const { results, news, ranking, calendar, gpName, sessions, sportLabel } = obj.data.getLgpPreviewWidget;

      const sessionsOrderedByDate = sessions.sort(
        (a, b): number => new Date(a.date).valueOf() - new Date(b.date).valueOf()
      );

      const links = results ? [calendar, results, ranking, news] : [calendar, ranking, news];

      return {
        gpName: gpName || '',
        sessions: sessionsOrderedByDate,
        links,
        sportLabel, 
      };
  } else {
    throw new WidgetError<ErrorName>({
      name: 'NO_VALID_DATA',
      message: 'Invalid transformer input, Error in LgpPreviewQuery object',
      data: obj
    });
  }
};
